export enum CREATED_BY {
  "GUEST" = "GUEST",
  "SYSTEM" = "SYSTEM",
  "CRON" = "CRON",
}
